<div fxLayout="row" fxLayoutAlign="end center">
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center">
        <label mat-dialog-title class="icon-library-head">Template Message</label>
    </div>
    <div class="row" style="padding-top:10px ;">
        <div class="btn-group" style="display: contents;">
            <button type="button" class="my-1 create-bot-btn btn" (click)="openText()" style="width: auto;border-radius: 8px;margin-right: 5px;">
                Text
            </button>
            <button type="button" class="my-1 create-bot-btn btn" (click)="openImage()" style = "width: auto;border-radius: 8px;margin-right: 5px;">
                Image
            </button>
            <button type="button" class="my-1 create-bot-btn btn" (click)="openVideo()" style = "width: auto;border-radius: 8px;margin-right: 5px;">
                Video
            </button>
            <button type="button" class="my-1 create-bot-btn btn" (click)="openDocument()" style = "width: auto;border-radius: 8px;margin-right: 5px;">
                Document
            </button>
            <button type="button" class="my-1 create-bot-btn btn" (click)="openImagewithBUtton()" style = "width: auto;border-radius: 8px;margin-right: 5px;">
                Image with Button
            </button>
            <button type="button" class="my-1 create-bot-btn btn" (click)="openTextwithBUtton()" style = "width: auto;border-radius: 8px;margin-right: 5px;">
                Text with Button
            </button>
        </div>
    </div>
    <div class="card-body px-5">
        <div>
            <div class="message-layout card" style="background-color: #F4F6FA;width: 270px;">
                <div class="card-body" style="padding: 0.5rem 0.7rem;">
                    <div style="border-radius: 8px;" *ngIf="imageTemp">
                        <img  src="../../../assets/preview-img.svg" style="width:100%;border-radius: 8px;">
                    </div>
                    <div style="border-radius: 8px;" *ngIf="imageButtonTemp">
                        <img  src="../../../assets/preview-img.svg" style="width:100%;border-radius: 8px;">
                    </div>
                    <div style="border-radius: 8px;" *ngIf="videoTemp">
                        <img  src="../../../assets/preview-video.svg" style="width:100%;border-radius: 8px;">
                    </div>
                    <div style="border-radius: 8px;" *ngIf="docuTemp">
                        <img  src="../../../assets/preview-docu.svg" style="width:100%;border-radius: 8px;">
                    </div>
                    <div class="pt-2" style="font-size: 13px;line-height: 130%;letter-spacing: -0.2px;white-space: pre-line; font-weight: 500;">
                        <label>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</label>
                    </div>
                </div>
                <div class="card-footer" style="background: #F4F6FA;border-top: none;" *ngIf="textButtonTemp || imageButtonTemp">
                    <div style="border-radius: 8px;" *ngIf="textButtonTemp">
                        <img src="../../../assets/preview-btn.svg" style="border-radius: 8px;width: 100%;">
                    </div>
                    <div style="border-radius: 8px;" *ngIf="imageButtonTemp">
                        <img  src="../../../assets/preview-btn.svg" style="border-radius: 8px;width: 100%;">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="px-3 py-3" style="font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;font-size: 12px;line-height: 15px; color: #999999;">
        <label>
            <!-- <a style="color: #386AF6;">Click here</a> 
            to check how to create {{templateType}} template -->
            Create predefined template using image, text & button.
        </label>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" style="width:100%">
        <button class="verify-btn" fxLayoutAlign="center center" fxFlex="100" style="padding: 8px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';
        font-style: normal;font-size: 14px; font-weight: normal; " [routerLink]="'/templates/add'" (click)="closePopup()">Create Now<mat-icon>
                chevron_right
            </mat-icon>
        </button>
    </div>
</div>